import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * <ScrollToTop /> — fixes the classic SPA pitfall where react-router keeps
 * the previous page's scroll position when you navigate. With this mounted
 * once inside <BrowserRouter>, every Link / navigate() lands the new page at
 * the top so the kid sees the hero / page title first.
 *
 * Hash links (#anchor) are preserved — anchor scroll behaviour stays intact.
 * `state.preserveScroll` opt-in lets specific pages skip the reset (none use
 * it today, but kept for future scenarios like infinite-scroll grids).
 */
export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    if (state && state.preserveScroll) return;
    if (hash) return; // browser handles in-page anchor scrolling
    if (pathname === "/travel" || pathname.startsWith("/travel/")) return; // Travel screens restore their own scroll (useScrollMemory)
    // Use rAF so the new route has painted before we scroll (avoids the
    // "scroll then layout shift" flash on slower devices).
    requestAnimationFrame(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      } catch {
        window.scrollTo(0, 0);
      }
    });
  }, [pathname, hash, state]);

  return null;
}
